import React, { Component } from "react";
import { FaTimes } from "react-icons/fa";
import { Flex, Input, List, ListItem, Text, Textarea } from "@chakra-ui/react";

class TldrTagsInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: [],
    };
  }

  removeTag = (i) => {
    const newTags = [...this.state.tags];
    newTags.splice(i, 1);
    this.setState({ tags: newTags });
  };

  addTag = (tagValue) => {
    const { applyTags } = this.props;
    const { tags } = this.state;

    if (tags.find((tag) => tag.toLowerCase() === tagValue.toLowerCase())) {
      return;
    }

    this.setState(
      {
        tags: [...tags, tagValue],
      },
      () => {
        if (applyTags) {
          applyTags([...tags, tagValue]);
        }
      }
    );

    this.tagInput.value = null;
  };

  inputKeyUp = (e) => {
    let val = e.target.value;
    val = val.replace(/,/g, "");
    this.tagInput.value = val;

    if (
      (e.key === "Enter" ||
        e.key === "," ||
        e.key === "Tab" ||
        (this.props.tagKey === "space" && e.key === " ")) &&
      val
    ) {
      this.addTag(val);
    } else if (e.key === "Backspace" && !val) {
      this.removeTag(this.state.tags.length - 1);
    }
  };

  inputFocusOut = (e) => {
    let val = e.target.value;
    val = val.replace(/,/g, "");
    this.tagInput.value = val;

    if (val) {
      this.addTag(val);
    }
  };

  render() {
    const { tags } = this.state;
    const { as, field, ...props } = this.props;

    return (
      <Flex
        flexWrap="nowrap"
        alignItems="center"
        w="full"
        px="1.5"
        pt="1.5"
        backgroundColor="brand.dark"
        border="1px solid"
        borderColor="gray.1000"
        borderRadius="8px"
      >
        <List display="inline-flex" flexWrap="wrap" m="0" p="0" w="97.5%">
          {tags.map((tag, i) => (
            <ListItem
              key={tag}
              display="flex"
              alignItems="center"
              background="whiteAlpha.300"
              borderRadius="30px"
              color="brand.white"
              fontSize="14px"
              listStyleType="none"
              mb="5px"
              mr="5px"
              px="5px"
              maxW="309px"
              h="31px"
              overflowWrap="anywhere"
            >
              <Text m="unset" pl="1">
                {tag}
              </Text>
              <Flex
                alignItems="center"
                appearance="none"
                background="gray.600"
                border="none"
                borderRadius="50%"
                color="brand.white"
                fontSize="9.5px"
                cursor="pointer"
                h="15px"
                justifyContent="center"
                ml="1"
                w="15px"
                onClick={() => this.removeTag(i)}
              >
                <FaTimes />
              </Flex>
            </ListItem>
          ))}
          <ListItem
            display="flex"
            alignItems="center"
            borderRadius="30px"
            color="brand.white"
            fontSize="14px"
            listStyleType="none"
            mb="5px"
            mr="5px"
            background="none"
            flexGrow="1"
            p="0"
          >
            {as === "input" ? (
              <Input
                background="none"
                border="none"
                type="text"
                onKeyUp={this.inputKeyUp}
                onBlur={this.inputFocusOut}
                ref={(c) => {
                  this.tagInput = c;
                }}
                h="30px"
                _hover={{ background: "none" }}
                _focus={{ background: "none" }}
              />
            ) : as === "textarea" ? (
              <Textarea
                type="text"
                onKeyUp={this.inputKeyUp}
                onBlur={this.inputFocusOut}
                ref={(c) => {
                  this.tagInput = c;
                }}
                placeholder={this.props?.placeholder}
                {...field}
                {...props}
              />
            ) : null}
          </ListItem>
        </List>
        {tags.length > 0 && (
          <div
            className="clear-tags-container"
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ tags: [] });
            }}
          >
            <FaTimes />
          </div>
        )}
      </Flex>
    );
  }
}

TldrTagsInput.propTypes = {};

export default TldrTagsInput;
